import axios from 'axios'
import semver from 'semver'
import packjson from '../../package.json'

let view = {}
view.title = function (title) {
  title = title || '管理平台'
  // window.document.title = title;
}

const ajaxUrl = ''

view.ajax = axios.create({
  baseURL: ajaxUrl,
  timeout: 30000,
})

view.inOf = function (arr, targetArr) {
  let res = true
  arr.forEach((item) => {
    if (targetArr.indexOf(item) < 0) {
      res = false
    }
  })
  return res
}

view.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true
  } else {
    return false
  }
}

view.showThisRoute = function (itAccess, currentAccess) {
  if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
    return view.oneOf(currentAccess, itAccess)
  } else {
    return itAccess === currentAccess
  }
}

view.getRouterObjByName = function (routers, name) {

  if (!name || !routers || !routers.length) {
    return null
  }
  // debugger;
  let routerObj = null
  for (let item of routers) {
    if (item.name === name) {
      return item
    }
    routerObj = view.getRouterObjByName(item.children, name)
    if (routerObj) {

      return routerObj
    }
  }
  return null
}

view.handleTitle = function (vm, item) {
  if (!item) {
    return
  }
  if (typeof item.title === 'object') {
    return vm.$t(item.title.i18n)
  } else {
    return item.title
  }
}

view.setCurrentPath = function (vm, name = '') {

  let title = ''
  let isOtherRouter = false
  vm.$store.state.app.routers.forEach((item) => {
    if (item.children) {
      if (item.children.length === 1) {
        if (item.children[0].name === name) {
          title = view.handleTitle(vm, item)
          if (item.name === 'otherRouter') {
            isOtherRouter = true
          }
        }
      } else {
        item.children.forEach((child) => {
          if (child.name === name) {
            title = view.handleTitle(vm, child)
            if (item.name === 'otherRouter') {
              isOtherRouter = true
            }
          }
        })
      }
    }
  })
  let currentPathArr = []

  if (name === 'index_index') {
    currentPathArr = [
      {
        title: view.handleTitle(vm, view.getRouterObjByName(vm.$store.state.app.routers, 'index_index')),
        path: '',
        name: 'index_index',
      },
    ]
  } else if ((name.indexOf('_index') >= 0 || isOtherRouter) && name !== 'index_index') {
    currentPathArr = [
      {
        title: view.handleTitle(vm, view.getRouterObjByName(vm.$store.state.app.routers, 'index_index')),
        path: '/index',
        name: 'index_index',
      },
      {
        title: title,
        path: '',
        name: name,
      },
    ]
  } else {

    let currentPathObj = vm.$store.state.app.routers.filter((item) => {
      // console.log(item.children, item.name)
      if (item.children && item.children.length > 0 && item.children.length <= 1) {
        return item.children[0].name === name
      } else {
        let i = 0
        let childArr = item ? item.children : []
        let len = childArr ? childArr.length : 0
        while (i < len) {
          if (childArr[i].name === name) {
            return true
          }
          i++
        }
        return false
      }
    })[0]
    if (currentPathObj) {
      return currentPathArr;
    }

    if (currentPathObj && currentPathObj.children.length <= 1 && currentPathObj.name === 'index') {
      currentPathArr = [
        {
          title: '首页',
          path: '',
          name: 'index_index',
        },
      ]
    } else if (currentPathObj && currentPathObj.children.length <= 1 && currentPathObj.name !== 'index') {
      currentPathArr = [
        {
          title: '首页',
          path: '/index',
          name: 'index_index',
        },
        {
          title: currentPathObj.title,
          path: '',
          name: name,
        },
      ]
    } else if (currentPathObj && currentPathObj.children) {
      let childObj = currentPathObj.children.filter((child) => {
        return child.name === name
      })[0]
      currentPathArr = [
        {
          title: '首页',
          path: '/index',
          name: 'index_index',
        },
        {
          title: currentPathObj.title,
          path: '',
          name: currentPathObj.name,
        },
        {
          title: childObj.title,
          // path: currentPathObj.path + '' + childObj.path,
          name: name,
        },
      ]
    }
  }

  vm.$store.commit('setCurrentPath', currentPathArr)

  return currentPathArr
}

view.openNewPage = function (vm, name, argu, query) {

  let pageOpenedList = (pageOpenedList = vm.$store.state.app.pageOpenedList)
  let openedPageLen = pageOpenedList.length
  let i = 0
  let tagHasOpened = false
  while (i < openedPageLen) {
    if (name === pageOpenedList[i].name) {
      // 页面已经打开
      vm.$store.commit('pageOpenedList', {
        index: i,
        argu: argu,
        query: query,
      })
      tagHasOpened = true
      break
    }
    i++
  }
  if (!tagHasOpened) {
    let tag = vm.$store.state.app.tagsList.filter((item) => {
      if (item.children) {
        return name === item.children[0].name
      } else {
        return name === item.name
      }
    })
    tag = tag[0]
    if (tag) {
      tag = tag.children ? tag.children[0] : tag
      if (argu) {
        tag.argu = argu
      }
      if (query) {
        tag.query = query
      }
      vm.$store.commit('increateTag', tag)
    }
  }
  vm.$store.commit('setCurrentPageName', name)
}

view.toDefaultPage = function (routers, name, route, next) {
  let MaintainerToken = global.$utils.data.get("", "token");
  // alert(window.location.href+"----------"+MaintainerToken)
  // console.log(routers, name, route);

  let len = routers.length
  let i = 0
  let notHandle = true
  while (i < len) {
    if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
      route.replace({
        name: routers[i].children[0].name,
      })
      notHandle = false
      next()
      break
    }
    i++
  }
  if (notHandle) {
    next()
  }
}

view.fullscreenEvent = function (vm) {
  // vm.$store.commit('initCachepage');
  // 权限菜单过滤相关
  vm.$store.commit('updateMenulist')
  // 全屏相关
}

export default view
